import { useState, useEffect, useCallback } from 'react';

var useDrag = function useDrag(_ref) {
  var position = _ref.position,
      minPosition = _ref.minPosition,
      maxPosition = _ref.maxPosition,
      onChange = _ref.onChange,
      onChangeEnd = _ref.onChangeEnd,
      isDisabled = _ref.isDisabled,
      defaultPosition = _ref.defaultPosition;

  var _useState = useState(false),
      isDragging = _useState[0],
      setIsDragging = _useState[1];

  var _useState2 = useState(position || defaultPosition),
      currentPosition = _useState2[0],
      setCurrentPosition = _useState2[1];

  var _useState3 = useState(0),
      initialOffset = _useState3[0],
      setInitialOffset = _useState3[1];

  var _useState4 = useState(0),
      initialClientPosition = _useState4[0],
      setInitialClientPosition = _useState4[1];

  useEffect(function () {
    setCurrentPosition(position || defaultPosition);
  }, [position, defaultPosition, setCurrentPosition]);
  var handleMouseMove = useCallback(function (event) {
    if (isDragging) {
      var position2;

      if (event.touches) {
        var touch = event.touches[0];

        if (touch) {
          position2 = touch.clientX;
        }
      } else {
        position2 = event.clientX;
      }

      var currentPosition2 = initialOffset + position2 - initialClientPosition;

      if (currentPosition2 >= minPosition && currentPosition2 <= maxPosition) {
        onChange == null ? void 0 : onChange(currentPosition2);
        setCurrentPosition(currentPosition2);
      }
    }
  }, [isDragging, onChange, initialOffset, maxPosition, minPosition, initialClientPosition]);
  var handleDragEnd = useCallback(function () {
    if (isDragging) {
      setIsDragging(false);
      onChangeEnd == null ? void 0 : onChangeEnd(currentPosition);
    }
  }, [isDragging, currentPosition, onChangeEnd]);

  var handleMouseDown = function handleMouseDown(event) {
    if (isDisabled) return;
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
    setInitialClientPosition(event.clientX);
    setInitialOffset(currentPosition);
  };

  var handleTouchStart = function handleTouchStart(event) {
    if (isDisabled) return;
    setIsDragging(true);

    if (event.touches) {
      var touch = event.touches[0];

      if (touch) {
        setInitialClientPosition(touch.clientX);
      }
    }

    setInitialOffset(currentPosition);
  };

  useEffect(function () {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("touchmove", handleMouseMove);
    window.addEventListener("mouseup", handleDragEnd);
    window.addEventListener("touchend", handleDragEnd);
    return function () {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchmove", handleMouseMove);
      window.removeEventListener("mouseup", handleDragEnd);
      window.removeEventListener("touchend", handleDragEnd);
    };
  }, [handleMouseMove, handleDragEnd]);
  return {
    currentPosition: currentPosition,
    isDragging: isDragging,
    handleMouseDown: handleMouseDown,
    handleTouchStart: handleTouchStart
  };
};

export { useDrag };